<div class="multi-stepper-container">
  <div class="stepper-item" *ngFor="let option of question.configuration.options">
    <span class="stepper-label">{{ option.value }}</span>
    <div class="stepper-controls">
      <button
        type="button"
        class="stepper-button"
        (click)="decrement(option.key, option.min)"
        [disabled]="stepperValues[option.key] <= option.min"
      >
        <span class="stepper-icon">−</span>
      </button>
      <span class="stepper-value">{{ stepperValues[option.key] }}</span>
      <button
        type="button"
        class="stepper-button"
        (click)="increment(option.key, option.max)"
        [disabled]="stepperValues[option.key] >= option.max"
      >
        <span class="stepper-icon">+</span>
      </button>
    </div>
  </div>
</div>
